import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import VideoBox from "../../casinoComponents/videoBox";
import BetTableTrio from "../../casinoComponents/betTableTrio";
import CasinoHeading from "../../casinoComponents/casinoHeading";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import MyBet from "../../casinoComponents/myBet";
import RefCardsOverlay from "../../casinoComponents/videoBox/overlays/RefCardsOverlay";
import ViewMoreModal from "../../../components/ViewMoreModal";
import TrioRefResults from "../resultui/resultTrio/TrioRefResults";
import VTrioView from "./VTrioView";
import { getCasinoGameDetails, getMatchExposure, getMyBets } from "../../../apiservices/CasionApi";
import { extractCasinoGame } from "../../../utils/casinoGame";
import { formatBetNation, formatBetOdds } from "../../../utils/casinoMyBets";
import "../../../styles/games/trio.css";

export default function Trio() {
  const [gameData, setGameData] = useState([]);
  const [data1, setData1] = useState([]);
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);

  const { pathname } = useLocation();

  useEffect(() => {
    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(extractCasinoGame(pathname) || "trio");
        setGameData(response);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);
    return () => clearInterval(interval);
  }, [pathname]);

  useEffect(() => {
    if (gameData) {
      const subData = gameData?.data?.data?.sub || gameData?.data?.sub || [];
      setData1(subData);
    }
  }, [gameData]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = gameData?.data?.data?.mid?.toString() || 
                      gameData?.data?.mid?.toString() || 
                      gameData?.mid?.toString();
      
      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            const teamName = item.team_name || item.selection || item.player_name || "";
            const exposureAmount = parseFloat(item.exposure_amount) || 0;
            if (teamName) {
              // Store with original case
              exposureMap[teamName] = exposureAmount;
              // Store with lowercase
              exposureMap[teamName.toLowerCase().trim()] = exposureAmount;
              // Store with trimmed version
              exposureMap[teamName.trim()] = exposureAmount;
              // Store with lowercase trimmed
              exposureMap[teamName.toLowerCase()] = exposureAmount;
            }
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error('Error fetching exposure:', error);
    }
  }, [gameData?.data?.data?.mid, gameData?.data?.mid, gameData?.mid]);

  const fetchMyBetsData = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = gameData?.data?.data?.mid?.toString() || 
                      gameData?.data?.mid?.toString() || 
                      gameData?.mid?.toString();
      
      if (userId && matchId) {
        const response = await getMyBets(userId, matchId);
        if (response.success && response.bets) {
          const formattedBets = response.bets.map((bet) => ({
            // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
            description: bet.description ?? bet.game_name ?? bet.gameName,
            userName: bet.userName ?? bet.username,
            placeDate: bet.placeDate ?? bet.created_at,
            matchedBet: bet.player_name || bet.selection || "",
            odds: bet.odds || "0",
            stake: bet.stake || "0",
            type: bet.type || null
          }));
          setMyBets(formattedBets);
        }
      }
    } catch (error) {
      console.error('Error fetching my bets:', error);
    }
  }, [gameData?.data?.data?.mid, gameData?.data?.mid, gameData?.mid]);

  useEffect(() => {
    if (gameData?.data?.data?.mid || gameData?.data?.mid || gameData?.mid) {
      fetchExposure();
      fetchMyBetsData();
      const exposureInterval = setInterval(() => {
        fetchExposure();
        fetchMyBetsData();
      }, 2000);
      return () => clearInterval(exposureInterval);
    }
  }, [gameData?.data?.data?.mid, gameData?.data?.mid, gameData?.mid, fetchExposure, fetchMyBetsData]);

  // Admin panel places no bets (the old PlaceBet slot was the NoBet stub): an odds click refreshes book + bets.
  const handleBetClick = (value) => {
    if (!value) return;
    fetchExposure();
    fetchMyBetsData();
  };

  const gameName = extractCasinoGame(pathname) || "trio";
  // Trio Session reads "Session-80" at its line 21
  const formatNation = (nat, bet) => formatBetNation(gameName, nat, bet);
  const formatRate = (bet) => formatBetOdds(gameName, bet, bet.odds ?? bet.userrate);
  const isVirtual = pathname.includes("/vcasino/");
  const d = gameData?.data?.data || gameData?.data || {};
  const roundId = d?.mid || "";
  const title = isVirtual ? "V-Trio" : "Trio";
  const viewMoreModal = (
    <ViewMoreModal
      show={showViewMoreModal}
      onHide={() => setShowViewMoreModal(false)}
      title="View More"
      sectionKey={gameName}
      formatNation={formatNation}
      formatRate={formatRate}
    />
  );

  if (isVirtual) {
    return (
      <VTrioView
        gameName={gameName}
        title={title}
        data={d}
        exposures={exposures}
        onBetClick={handleBetClick}
        myBets={myBets}
        onViewMore={() => setShowViewMoreModal(true)}
        viewMoreModal={viewMoreModal}
      />
    );
  }

  return (
    <CasinoTableLayout
      tableClass="pasa"
      rightSide={<MyBet bets={myBets} onViewMore={() => setShowViewMoreModal(true)} formatNation={formatNation} formatRate={formatRate} />}
    >
      <>
        <CasinoHeading name={title} roundId={roundId} />
        <VideoBox
          gameType={gameName}
          resultData={d?.card}
          iframeSrc={`https://stream-s-43.uhdmovies.online/casino-stream?id=${gameName}`}
          timerValue={d?.lt}
          cardsOverlay={<RefCardsOverlay card={d?.card} count={3} wrap />}
        />
        {roundId ? (
          <div className="casino-detail">
            <BetTableTrio data={data1} onBetClick={handleBetClick} exposures={exposures} />{" "}
            {d?.remark ? (
              <div className="casino-remark mt-3">
                <div className="remark-icon">
                  <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} alt="" />
                </div>{" "}
                <marquee>{d.remark}</marquee>
              </div>
            ) : null}{" "}
            <CasinoLastResult
              gameType={gameName}
              resultComponent={<TrioRefResults gameType={gameName} fallbackTitle={title} roundId={roundId} />}
            />
          </div>
        ) : null}
      </>
      {viewMoreModal}
    </CasinoTableLayout>
  );
}
